import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { ApiSuccess } from "@/interfaces/common/Success";
import { ClientNotification } from "@/interfaces/domain/Client";
import {
  getClientNotificationListRequest,
  removeClientNotificationRequest,
} from "@/services/api/client";
import { logger } from "@/services/logger";

import { useAppSelector } from "../application/store";

export const NOTIFICATIONS_QUERY_KEY = ["client-notifications"];

export const useClientNotifications = (options?: UseQueryOptions<ClientNotification[]>) => {
  const { user } = useAppSelector((store) => store.auth);

  return useQuery<ClientNotification[]>({
    queryKey: NOTIFICATIONS_QUERY_KEY,
    queryFn: () => getClientNotificationListRequest(user?.cliente?._id),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });
};

export const useRemoveNotification = (
  options?: UseMutationOptions<ApiSuccess, unknown, string>
) => {
  const { user } = useAppSelector((store) => store.auth);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) =>
      removeClientNotificationRequest(user?.cliente?._id, notificationId),
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.refetchQueries(NOTIFICATIONS_QUERY_KEY);
      options?.onSuccess(data, variables, context);
    },
    onError: (error, variables, context) => {
      logger.error(error);
      options?.onError(error, variables, context);
    },
  });
};
